module.exports = " <div class=session_list _v-6427e454=\"\"> <session-list-item v-for=\"indexNode of sessionMapIndex\" :sid=indexNode.sid :timeline=indexNode.timestamps :complete-session-map=completeSessionMap _v-6427e454=\"\"></session-list-item> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6427e454!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/sidebar/SessionList.vue
 ** module id = 351
 ** module chunks = 2
 **/